import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { PageHeader } from "@/components/StatusBadge";
import { ChangePasswordForm } from "@/components/auth/ChangePasswordForm";

export default function Profile() {
  const { user, meta, refresh } = useAuth();
  const [f, setF] = useState({ phone: user.phone || "", notify_sms: !!user.notify_sms, notify_whatsapp: !!user.notify_whatsapp });
  const n = meta.notifications;
  const save = async () => { try { await api.patch("/profile", f); toast.success("Notification settings saved"); refresh(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="max-w-xl">
      <PageHeader eyebrow="Account" title="Notification settings" testid="profile-title" />
      <div className="rounded-lg border border-slate-200 bg-white shadow-sm p-5 space-y-5">
        <div className="text-sm text-slate-600">In-app notifications are always on. SMS and WhatsApp are sent via Twilio when the organisation has configured it.</div>
        <div className="space-y-1.5"><Label className="text-xs">Mobile number (international format, e.g. +234…)</Label>
          <Input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="profile-phone" /></div>
        {[["notify_sms", "SMS alerts", n.sms], ["notify_whatsapp", "WhatsApp alerts", n.whatsapp]].map(([k, label, on]) => (
          <div key={k} className="flex items-center justify-between">
            <div><div className="text-sm font-medium">{label}</div><div className="text-xs text-slate-500" data-testid={`${k}-status`}>{on ? "Available" : "Not configured yet — preference saved for later"}</div></div>
            <Switch checked={f[k]} onCheckedChange={(v) => setF({ ...f, [k]: v })} data-testid={`profile-${k}`} />
          </div>
        ))}
        <Button onClick={save} data-testid="profile-save">Save</Button>
      </div>
      <h2 className="mt-8 mb-3 font-semibold text-slate-900">Change password</h2>
      <div className="rounded-lg border border-slate-200 bg-white shadow-sm p-5"><ChangePasswordForm /></div>
    </div>
  );
}
